import {Typography } from 'antd';
import { Gmail } from '../../assets/images';


interface Props {
    image: any;
    title: any;
    category: any;
    mail: any;
}

const TeamsCard = (props: Props) => {
    return (
        <div>
            <Typography.Title level={4}>{props.title}</Typography.Title>
            {props.category && <Typography.Text>{props.category} </Typography.Text>}
            {props.mail && <a href={`mailto:${props.mail}`}><Gmail />{props.mail}</a>}
        </div>
    )
}


export default TeamsCard;